import { Paper, Table, TableBody, TableContainer } from '@mui/material'
import { MouseEvent } from 'react'
import { RootNodesQuery } from '../../../apollo/configurator/queries/RootNodes.generated'
import { Order, OrderBy } from '../utils/modelUtils'
import { ModelListTableHeader } from './ModelListTableHeader'
import { ModelListTableRow } from './ModelListTableRow'

type ModelNode = RootNodesQuery['configuratorNodes'][0]

interface ModelListTableProps {
    paginatedModels: ModelNode[]
    filteredModelsLength: number
    selected: string[]
    order: Order
    orderBy: OrderBy
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void
    onSelectClick: (id: string) => void
    onRequestSort: (property: OrderBy) => void
    isSelected: (id: string) => boolean
    onExportClick: (e: MouseEvent<HTMLButtonElement>, id: string) => void
    onDuplicateClick: (e: MouseEvent<HTMLButtonElement>, id: string) => void
    onRowClick: (id: string) => void
}

export const ModelListTable: React.FC<ModelListTableProps> = ({
    paginatedModels,
    filteredModelsLength,
    selected,
    order,
    orderBy,
    onSelectAllClick,
    onSelectClick,
    onRequestSort,
    isSelected,
    onExportClick,
    onDuplicateClick,
    onRowClick
}) => {
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer>
                <Table>
                    <ModelListTableHeader
                        selected={selected}
                        filteredModelsLength={filteredModelsLength}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={onSelectAllClick}
                        onRequestSort={onRequestSort}
                    />
                    <TableBody>
                        {paginatedModels.map((model) => (
                            <ModelListTableRow
                                key={model.id}
                                model={model}
                                isSelected={isSelected(model.id.toString())}
                                onSelectClick={onSelectClick}
                                onExportClick={onExportClick}
                                onDuplicateClick={onDuplicateClick}
                                onRowClick={onRowClick}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}
